Ext.define('SA.model.DatasetCensusReleases', {
    constructor({censusReleases}) {
        this.censusReleases = censusReleases;
    },

    getEditionsForCensusReleaseYear(censusReleaseYear) {
        return this.censusReleases[censusReleaseYear].getEditions();
    },

    getLatestEditionForCensusReleaseYear(censusReleaseYear) {
        return this.censusReleases[censusReleaseYear].getLatestEdition();
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return Reflect.has(this.censusReleases, censusReleaseYear);
    },

    hasEditionInCensusRelease({edition, censusReleaseYear}) {
        return this.censusReleases[censusReleaseYear].hasEdition(edition);
    }
});